import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=5d9f8836&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9f8836')) {
      api.createRecord('5d9f8836', component.options)
    } else {
      api.reload('5d9f8836', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=5d9f8836&", function () {
      api.rerender('5d9f8836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SZV0qQX7VOVf/JS/ImageCarousel.vue"
export default component.exports